<div class="container-vehicle">
    <span class="container-vehicle__title">
        {{'update'|translate}}: <span class="bold">{{lastUpdated|statusTimeFormat}}</span>
    </span>

    <div class="container-vehicle__list">
        <button 
            *ngFor="let item of slots; let index = index"
            (click)="onClickSlot(index)"
            [ngClass]="{ 'active': index === activeSlotIndex, 'is-online': true }"
            class="container-vehicle__list__slot"
        >
            <span class="container-vehicle__list__slot__title">
                Slot {{ index + 1 }}
            </span>
        </button>
    </div>
</div>